"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _EventButton = _interopRequireDefault(require("../../../atoms/EventButton/EventButton"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Indicator = function Indicator(_ref) {
  var index = _ref.index,
      currentIndex = _ref.currentIndex,
      changeCurrentIndex = _ref.changeCurrentIndex,
      event = _ref.event;
  return /*#__PURE__*/_react["default"].createElement(_EventButton["default"], {
    event: _objectSpread({}, event, {
      value: index
    }),
    className: "ic-carousel-indicator",
    style: {
      padding: 0,
      background: 'none'
    },
    onClick: function onClick() {
      return changeCurrentIndex(index);
    },
    size: "large",
    icon: index === currentIndex ? 'circle' : 'circle outline'
  });
};

Indicator.propTypes = {
  event: _propTypes["default"].shape({}),
  index: _propTypes["default"].string.isRequired,
  currentIndex: _propTypes["default"].number.isRequired,
  changeCurrentIndex: _propTypes["default"].func.isRequired
};
Indicator.defaultProps = {
  event: {
    category: 'Carousel',
    action: 'Click',
    label: 'Image Collection'
  }
};
var _default = Indicator;
exports["default"] = _default;